import { useCallback, useEffect, useState } from "react";
import { apiService } from "../api/services/apiService";
import type { OperationalError } from "../types";

export function useOperationalErrors() {
  const [errors, setErrors] = useState<OperationalError[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const list = await apiService.getOperationalErrors();
      setErrors(list);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Failed to load operational errors");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { errors, loading, error, refresh };
}
